interface FeatureStatusProps {
    status: 'stable' | 'beta' | 'coming';
}

const LABEL: Record<FeatureStatusProps['status'], string> = {
    stable: 'Disponible',
    beta: 'Bêta',
    coming: 'Bientôt',
};

export function FeatureStatus({ status }: FeatureStatusProps) {
    return <span className={`doc-status doc-status-${status}`}>{LABEL[status]}</span>;
}
